import React, {useState} from "react";
import {useConsentStore} from "../../../lib/store/consent-store";
import Cookies from 'js-cookie'
import {Button} from "../primitives/button/button";
import Portal from "../portal/portal";

const Consent = () => {
  const [isVisible, setVisible] = React.useState(true);
  const [isFullConsentVisible, setFullConsentVisible] = React.useState(false);

  const updateConsent = useConsentStore((state) => state.updateConsent);
  const consent = useConsentStore((state) => state.consent);

  const handleConfirmConsent = () => {
    Cookies.set("consent", "true");
    setVisible(false);
    setFullConsentVisible(false);
    updateConsent(true);
  };

  const handleClose = () => {
    setVisible(false);
    setFullConsentVisible(false)
  }

  React.useEffect(() => {
    const cookieConsent = Cookies.get("consent");
    if (cookieConsent === "true" || consent) {
      setVisible(false);
      updateConsent(true);
    }
  }, []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!consent) {
        setFullConsentVisible(true);
        setVisible(false)
      }
    }, 20000); // 20 сек

    return () => clearTimeout(timer); // Очистка при размонтировании
  }, []);

  return (
    <>
      {isVisible && <div className="fixed z-50 bottom-5 right-5 p-5 bg-plt-white rounded-lg max-w-[350px] shadow-md">
        <p>
          Продолжая пользоваться сайтом, вы соглашаетесь на использование cookie и
          обработку данных согласно{" "}
          <a
              className="consent-link"
              href="/docs/ПОЛИТИКА%20КОНФИДЕНЦИАЛЬНОСТИ%20ЖК%20ОЛИМП.docx"
              target="_blank"
          >
            Политикe конфиденциальности
          </a>
          .
        </p>
        <div className='mt-3 flex gap-2'>
          <Button onClick={handleConfirmConsent}>Согласен</Button>
          <Button variant='ghost' onClick={handleClose}>
            Закрыть
          </Button>
        </div>
      </div>}

      {(isFullConsentVisible && !consent) && <Portal>
        <div
            className='fixed top-0 right-0 bottom-0 left-0 bg-black/50 z-50 flex items-center justify-center w-full '>
          <div className="max-w-[345px] w-full bg-white p-5 rounded-md shadow-2xl">
            <p>
              Продолжая пользоваться сайтом, вы соглашаетесь на использование cookie и
              обработку данных согласно{" "}
              <a
                  className=""
                  href="/Политика конфиденциальности.pdf"
                  target="_blank"
              >
                Политикe конфиденциальности
              </a>
              .
            </p>
            <div className='mt-3 flex items-center gap-2'>
              <button className="bg-[#bb9056] text-white px-6 py-2 rounded" onClick={handleConfirmConsent}>
                Согласен
              </button>
              <button className="px-6 py-2 rounded border border-[#bb9056]" onClick={handleClose}>
                Отказаться
              </button>
            </div>
          </div>
        </div>
      </Portal>}
    </>
  );
};

export default Consent;
